<template>
  <div class="flex flex-col items-center my-4 relative">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>

    <!-- TODO: refactorizar en componentes reutilizables  -->

    <div class="w-full mb-4">
      <table class="w-full border border-gray-300">
        <thead class="bg-blue-dark">
          <tr>
            <th class="p-2 text-sm font-semibold uppercase text-white">{{ $t("pages") }}</th>
            <th class="p-2 text-sm font-semibold uppercase text-white">{{ $t("configurations") }}</th>
            <th class="p-2 text-sm font-semibold uppercase text-white flex items-center justify-center">
              <b-dropdown aria-role="list"
                position="is-bottom-left"
              >
                <template #trigger="{ active }">
                    <b-button
                        label="Acciones"
                        type="is-primary"
                        icon-pack="fas"
                        size="is-small"
                        :icon-right="active ? 'chevron-up' : 'chevron-down'"
                    />
                </template>
                <b-dropdown-item aria-role="listitem" @click="handleClickAddSetting('pages')">{{ $t('add_setting') }}</b-dropdown-item>
              </b-dropdown>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="cfg in config.pages" class="hover:bg-gray-50 transition">
            <td class="justify-start w-auto h-full p-4 align-middle font-medium">
              <div class="flex align-middle font-semibold text-blue">
                <b-tooltip v-if="cfg.description"
                  :label="cfg.description"
                  multilined
                  position="is-right"
                  >
                  <span class="mr-1 cursor-help">{{ cfg.name }}</span>
                </b-tooltip>
                <span v-else>{{ cfg.name }}</span>
              </div>
            </td>

            <td class="p-2">
              <page-cover-display v-if="cfg.code === 'REPORT_COVER'"
                :config-page="cfg"
                :activity-groups="activityGroups"
              />

              <page-summary-display v-if="cfg.code === 'RAG_SUMMARY'"
                :config-page="cfg"
                :activity-groups="activityGroups"
              />

              <line-selector-display v-if="cfg.code === 'LINE_SELECTOR'"
                :config-page="cfg"
                :activity-groups="activityGroups"
              />

              <task-column-selector-display v-if="cfg.code === 'TASK_COLUMNS_SELECTOR'"
                :config-page="cfg"
                :activity-groups="activityGroups"
              />
            </td>

            <td class="p-2">
              <div class="flex items-center justify-center">
                <b-button type="is-primary" icon-right="cog" icon-pack="fas" @click="openConfigForm('page', cfg)"/>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="w-full mb-4">
      <table class="w-full border border-gray-300">
        <thead class="bg-blue-dark">
          <tr>
            <th class="p-2 text-sm font-semibold uppercase text-white">{{ $t("sections") }}</th>
            <th class="p-2 text-sm font-semibold uppercase text-white">{{ $t("configurations") }}</th>
            <th class="p-2 text-sm font-semibold uppercase text-white flex items-center justify-center">
              <b-dropdown aria-role="list"
                position="is-bottom-left"
              >
                <template #trigger="{ active }">
                    <b-button
                        label="Acciones"
                        type="is-primary"
                        icon-pack="fas"
                        size="is-small"
                        :icon-right="active ? 'chevron-up' : 'chevron-down'"
                    />
                </template>
                <b-dropdown-item aria-role="listitem" @click="handleClickAddSetting('sections')">{{ $t('add_setting') }}</b-dropdown-item>
              </b-dropdown>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="cfg in config.sections" class="hover:bg-gray-50 transition">
            <td class="justify-start w-auto h-full p-4 align-middle font-medium">
              <div class="flex align-middle font-semibold text-blue">
                <b-tooltip v-if="cfg.description"
                  :label="cfg.description"
                  multilined
                  position="is-right"
                  >
                  <span class="cursor-help">{{ cfg.name }}</span>
                </b-tooltip>
                <span v-else>{{ cfg.name }}</span>
              </div>
            </td>

            <td class="p-2">
              <section-display
                :config-section="cfg"
                :activity-groups="activityGroups"
              />
            </td>

            <td class="p-2">
              <div class="flex items-center justify-center">
                <b-button type="is-primary" icon-right="cog" icon-pack="fas" @click="openConfigForm('section', cfg)"/>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="w-full">
      <div class="flex items-end justify-end space-x-2">
        <div v-if="!processingData"
          class="w-fullflex items-end justify-end mb-2 mt-2">
          <v-button type="button" icon="cog" icon-pack="fas" class="mr-4" @click="saveConfig">{{ $t('save_configuration') }}</v-button>
          <!-- <v-button color="grey" icon="undo-alt" @click="isModalActive = false">{{ $t('cancel') }}</v-button> -->
        </div>

        <v-button-processing v-if="processingData" />
      </div>
    </div>

    <config-modal ref="refConfigModal"
      :form-component="formComponent"
      :form-data="formData"
      :activity-groups="activityGroups"
      :report-configs="config"
      :modal-title="modalTitle"
      @epc-saving="handleSaving"
      @epc-saved="handleSaved"
    />

  </div>
</template>

<script>

import ConfigModal from '../modals/ConfigModal.vue';

import PageCoverConfigForm from '../forms/PageCoverConfigForm.vue';
import PageSummaryConfigForm from '../forms/PageSummaryConfigForm.vue';
import SectionConfigForm from '../forms/SectionConfigForm.vue';
import TaskColumnSelectorConfigForm from '../forms/PageTaskColumSelectorConfigForm.vue';
import LineSelectorConfigForm from '../forms/LineSelectorConfigForm.vue';

import PageSummaryDisplay from '../views/PageSummaryDisplay.vue';
import PageCoverDisplay from '../views/PageCoverDisplay.vue';
import SectionDisplay from '../views/SectionConfigDisplay.vue';
import LineSelectorDisplay from '../views/LineSelectorDisplay.vue';
import TaskColumnSelectorDisplay from '../views/TaskColumnSelectorDisplay.vue';

import { saveReportConfig } from '../services/report-detail.service';

export default {
  name: 'config-detailed-report-table',

  components: {
    ConfigModal,
    PageCoverDisplay,
    PageSummaryDisplay,
    SectionDisplay,
    LineSelectorDisplay,
    TaskColumnSelectorDisplay,
  },

  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    activityGroups: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      formComponent: null, // Componente del formulario a mostrar en el modal
      formData: {}, // Datos del formulario a mostrar en el modal
      modalTitle: 'Configuración de la página',
      processingData: false, // Indica si se está procesando una acción
      isLoading: false, // Indica si se está cargando información
    }
  },

  computed: {

  },

  methods: {
    openConfigForm(type, cfg) {
      this.formData = cfg;

      if (type === 'page') {
        const pageComponentMap = {
          RAG_SUMMARY: PageSummaryConfigForm,
          REPORT_COVER: PageCoverConfigForm,
          TASK_COLUMNS_SELECTOR: TaskColumnSelectorConfigForm,
          LINE_SELECTOR: LineSelectorConfigForm,
        };

        this.modalTitle = `${this.$t('configure')}: ${cfg.name}`;
        this.formComponent = pageComponentMap[cfg.code] || null;

      } else if (type === 'section') {
        this.formComponent = SectionConfigForm;
        this.modalTitle = `${this.$t('configure')}: ${this.$t('section')}`;
      }

      this.$refs.refConfigModal.show();
    },

    handleClickAddSetting(type) {
      this.formData = {
        id: null,
        code: null,
        name: null,
        description: null,
        settingType: type,
      };

      this.formComponent = () => import('../forms/AddConfigForm.vue');
      this.modalTitle = `${this.$t('add_setting')}`;
      this.$refs.refConfigModal.show();
    },

    handleSaving() {
      this.isLoading = true;
    },

    handleSaved(data) {
      this.$refs.refConfigModal.hide();
      // lógica adicional tras guardar

      this.isLoading = false;
      this.$emit('epc-request-refresh');
    },

    async saveConfig() {
      this.isLoading = true;

      try {
        await saveReportConfig(this.projectId, this.config);

        this.$toast.open({
          message: this.$t('configuration_saved'),
          type: 'is-success',
          duration: 3000,
        });
      } catch (error) {
        this.$toast.open({
          message: this.$t('error_saving_configuration'),
          type: 'is-danger',
          duration: 5000,
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>